<header class="app-header" *ngIf="accountService.user && showHeader">
  <div class="header-container">
    <!-- Logo Left -->
    <div class="logo">
      <a routerLink="/">
        <img src="./assets/images/Hanwha_Philly_Shipyard.png" alt="Logo" />
      </a>
    </div>

    <!-- Navigation Center -->
    <nav class="nav-links">
      @for(link of midLinks; track link.path) {
      <a [routerLink]="link.path" routerLinkActive="active" class="nav-link">
        {{ link.title }}
      </a>
      }
    </nav>

    <!-- User Dropdown Right -->
    <div class="user-menu">
      <button mat-button [matMenuTriggerFor]="userDropDown" class="user-btn">
        <span>{{ accountService.user.firstName }} {{ accountService.user.lastName }}</span>
      </button>
    </div>
  </div>
</header>

<!-- Dropdown -->
<mat-menu #userDropDown="matMenu" class="modern-menu">
  <button mat-menu-item [routerLink]="['/change-password']">
    Change Password
  </button>
  <button mat-menu-item (click)="accountService.logout()">
    Log Out
  </button>
</mat-menu>

@if(busyService.loading) {
<mat-progress-bar mode="indeterminate" color="primary" style="position: fixed; width: 100%;  z-index: 1000;"
  [style.top]="'0'"></mat-progress-bar>
}